module.exports = __webpack_public_path__ + "static/media/icon-typescript.42766c99.svg";